/**
 * @ngdoc directive
 * @name header
 *
 * @description
 * Page header
 */
module.directive('header', function () {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$rootScope', '$scope', function ($rootScope, $scope) {
            $scope.site = $rootScope.site;
        }],
        template:
                '<div ng-switch="site.id">' +
                '  <headeravenir ng-switch-when="avenir"></headeravenir>' +
                '  <headerpanel ng-switch-when="b2c"></headerpanel>' +
                '</div>'
    };
});

/**
 * @ngdoc service
 * @name scrolllocker
 *
 * @description
 * Lock scroll
 */
module.factory('scrolllocker', ['$document', function ($document) {
    'use strict';
    return {
        lock: function () {
            $document.find('body').addClass('is-scroll-locked');
        },
        unlock: function () {
            $document.find('body').removeClass('is-scroll-locked');
        }
    };
}]);

/**
 * @ngdoc service
 * @name donationsticky
 *
 * @description
 * Switch sticky button visibility (css)
 */
module.factory('donationsticky', ['$rootScope', function ($rootScope) {
    'use strict';
    return {
        enable: function () {
            $rootScope.$broadcast('stickyShow');
        },
        disable: function () {
            $rootScope.$broadcast('stickyHide');
        }
    };
}]);